import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import JobDetails from "../Job/JobDetails";
import Loader from "../../Loader/Loader";
import BidDetailSubmit from "./SubmitBidView";
import BidUpdateSubmit from "./UpdateBidView";
import ViewBidOnly from "./ViewBidOnly";
import JobResultModal from "../Job/JobResultModal/JobResultModal";
import { hitGetJobDetailsWithBidProfessionalApi } from "../../../Redux/Professional/JobDetailsWithBidSlice";
import BrowseAvailableJobs from "../../../assets/img/Browse Available Jobs.svg";

const JobDetailFullView = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);

  const isBidFocusLayout =
    searchParams.get("focus") === "bid" || searchParams.get("view") === "bid";

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigation("/professional/login");
      return;
    }
    if (!jobId) return;
    setLoading(true);
    dispatch(hitGetJobDetailsWithBidProfessionalApi({ jobId }));
  }, [dispatch, jobId, navigation]);

  useEffect(() => {
    if (!jobId) return;
    dispatch(hitGetJobDetailsWithBidProfessionalApi({ jobId }));
  }, [dispatch, jobId, location.key]);

  const responseJobDetailsWithBidProfessional = useSelector(
    (state) => state.getJobDetailsWithBidProfessionalReducer.data
  );

  useEffect(() => {
    if (responseJobDetailsWithBidProfessional?.status === true) {
      setLoading(false);
      setJobData(responseJobDetailsWithBidProfessional.data);
    }
  }, [responseJobDetailsWithBidProfessional]);

  if (loading) {
    return (
      <div style={{ height: "100vh" }}>
        <Loader />
      </div>
    );
  }

  const handleBackToListing = () => {
    navigation("/professional/jobs");
  };

  const handleBackToJobDetails = () => {
    navigation(`/professional/job-details/${jobId}`);
  };

  return (
    <div
      className={`browse-jobs pro-app-page${
        isBidFocusLayout ? "" : " browse-jobs--details-only"
      }`}
    >
      <div className="custom_container">
        {isBidFocusLayout && (
          <div className="header">
            <div
              className="title"
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
              onClick={handleBackToJobDetails}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  handleBackToJobDetails();
                }
              }}
            >
              <img src={BrowseAvailableJobs} alt="Browse Available Jobs" />
              <span>Back to Job Details</span>
            </div>
          </div>
        )}

        {!isBidFocusLayout && jobData && (
          <JobDetails
            jobData={jobData}
            jobListData={[]}
            setJobListData={() => {}}
            openModal={() => setModalOpen(true)}
            onBackToJobs={handleBackToListing}
          />
        )}

        {isBidFocusLayout && (
          <Row className="job-fullview-row job-fullview-row--bid-only">
            {jobData && jobData.isBidPlaced === 0 && (
              <Col xs={12}>
                <BidDetailSubmit jobData={jobData} />
              </Col>
            )}
            {jobData &&
              jobData.isBidPlaced !== 0 &&
              jobData?.bidData?.status !== 2 && (
                <Col xs={12}>
                  <BidUpdateSubmit jobData={jobData} />
                </Col>
              )}
            {jobData && jobData?.bidData?.status === 2 && (
              <Col xs={12}>
                <ViewBidOnly jobData={jobData} />
              </Col>
            )}
          </Row>
        )}

        {isModalOpen && (
          <JobResultModal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default JobDetailFullView;
